import { render, staticRenderFns } from "./ApplianceModelForm.vue?vue&type=template&id=06980f2f"
import script from "./ApplianceModelForm.vue?vue&type=script&lang=js"
export * from "./ApplianceModelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports